export interface AdminStaffCallRatioStatsDTO {
  contactName: string;
  callMonthYear: string;
  customerCount: number;
  calls: number;
  callToCustomerRatio: number;
}
